import React, { Component } from 'react';
import { Redirect } from 'react-router'
import { reduxForm } from 'redux-form';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import _ from 'lodash';
import qs from 'qs';

import TopNavBar from '../../containers/top-nav-bar.container';
import FacebookButton from '../../containers/facebook-button.container';
import EmailField from './email-field';
import PasswordField from './password-field';
import GuestAccountField from './guest-account-field';
import Alert from '../../components/alert';
import Loading from '../../../components/loading';
import { formatMessage } from '../../lib/intl';

const i18n = defineMessages({
  badEmail: {
    id: 'singinForm.errors.email',
    defaultMessage: 'Enter your email to sign in',
  },
  badPassword: {
    id: 'signinForm.errors.password',
    defaultMessage: 'Enter your password to sign in',
  },
  invalidToken: {
    id: 'signinForm.errors.invalidToken',
    defaultMessage: 'Invalid email or token',
  },
  unauthenticated: {
    id: 'signinForm.errors.unauthenticated',
    defaultMessage: 'Invalid e-mail or password.',
  },
});

class SignIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: null,
      password: null,
      error: null,
    };

    this.formatMessage = formatMessage(this.props.intl);

    this.onEmailChange = _.debounce(this.onEmailChange.bind(this), 500);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onClickSendMagicLink = this.onClickSendMagicLink.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.currentUser && nextProps.currentUser) {
      const query = qs.parse(this.props.location.search.substring(1));

      return <Redirect to={query.redirect || '/my-groups'} />;
    }
  }

  onEmailChange(value) {
    this.setState({
      email: value,
      error: null,
    });

    this.props.onEmailChange(value);
  }

  onPasswordChange(value) {
    this.setState({
      password: value,
      error: null,
    });

    this.props.onPasswordChange(value);
  }

  onSubmit() {
    this.props.onSignin(this.state.email, this.state.password)
      .catch(() => {
        this.setState({
          error: this.formatMessage(i18n.unauthenticated),
        });
      });
  }

  onClickSendMagicLink() {
    this.props.onClickSendMagicLink(this.state.email);
  }

  getClassName() {
    if (this.props.inModal) return 'in-modal login';
    return 'login';
  }

  isGuestAccount() {
    return this.props.existence === 'guest';
  }

  loginWithToken() {
    if (this.state.tokenError) {
      return;
    }

    const query = qs.parse(this.props.location.search.substring(1));

    if (!query.email && !query.token) {
      return;
    }

    const params = {
      email: query.email,
      token: query.token,
    };

    this.props.onLoginWithToken(params)
      .catch(() => {
        this.setState({
          error: this.formatMessage(i18n.invalidToken),
          tokenError: true,
        });
      });
  }

  renderAlert() {
    if (!this.state.error) return undefined;
    return (
      <Alert type="warning" className="alert-form-top">
        <i className="fa fa-fw fa-ban" />
        {this.state.error}
      </Alert>
    );
  }

  renderPasswordField() {
    if (this.isGuestAccount()) {
      return (
        <div>
          <GuestAccountField
            onClickHandler={this.onClickSendMagicLink}
          />
        </div>
      );
    }

    const query = qs.parse(this.props.location.search.substring(1));
    const passwordResetLink = query.redirect ? `/password-reset?redirect=${query.redirect}`
      : `/password-reset`;
    return (
      <div>
        <small className="mt-2 pull-right">
          <a tabIndex="-1" href={passwordResetLink}>
            <FormattedMessage
              id="signinForm.forgorPassword"
              defaultMessage="Forgot?"
            />
          </a>
        </small>
        <PasswordField
          onPasswordChange={this.onPasswordChange}
        />
      </div>
    );
  }

  renderSubmitButton() {
    if (this.isGuestAccount()) return;

    return (
      <button type="submit" className="btn btn-primary full-width">
        <FormattedMessage
          id="signinForm.submitButton.label"
          defaultMessage="Sign in"
        />
      </button>
    );
  }

  renderLoginForm() {
    const { handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit(props => this.onSubmit(props))}>
        <div className="modal-section">
          <EmailField
            onEmailChange={this.onEmailChange}
          />
          {this.renderPasswordField()}
        </div>
        {this.renderSubmitButton()}
      </form>
    );
  }

  renderFacebookButton() {
    if (this.isGuestAccount()) return;

    return (
      <div className="modal-section divider">
        <FacebookButton onConnect={this.props.onLogin}>
          <FormattedMessage
            id="signinForm.facebookButton"
            defaultMessage="Sign in with Facebook"
          />
        </FacebookButton>
      </div>
    );
  }

  render() {
    if (this.props.currentUser) return <Loading />;

    const query = qs.parse(this.props.location.search.substring(1));
    const signupLink = query.redirect ? `/signup?redirect=${query.redirect}` : '/signup';

    this.loginWithToken();

    return (
      <div className={this.getClassName()}>
        <TopNavBar user={this.props.currentUser} signinPage={true} />
        <div className="row justify-content-center mt-4 pt-4">
          <div className="modal-page">
            <div className="card m-auto">
              <div className="card-block">
                <div>
                  {this.renderAlert()}
                  <div className="modal-section modal-title text-center divider">
                    <h1>
                      <FormattedMessage
                        id="signinForm.pageTitle"
                        defaultMessage="Sign in"
                      />
                    </h1>
                    <div className="text-muted">
                      <FormattedMessage
                        id="signinForm.welcomeText"
                        defaultMessage="Welcome back"
                      />
                    </div>
                  </div>

                  {this.renderFacebookButton()}

                  {this.renderLoginForm()}
                  <div className="modal-section no-account">
                    <p className="text-muted">
                      {' '}
                      <a href={signupLink}>
                        <FormattedMessage
                          id="signinForm.signupLink"
                          defaultMessage="Sign up"
                        />
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SignIn.defaultProps = {
  onEmailChange: () => { },
  onPasswordChange: () => { },
  onClickSendMagicLink: () => { },
  onLoginWithToken: () => { },
  onSignin: () => { },
  inModal: false,
  currentUser: null,
};

const validate = (values, props) => {
  const { intl: { formatMessage } } = props;
  const errors = {};

  if (!values.email) {
    errors.email = formatMessage(i18n.badEmail);
  }

  if (!values.password) {
    errors.password = formatMessage(i18n.badPassword);
  }

  return errors;
};

export default injectIntl(reduxForm({
  validate,
  form: 'signIn',
})(SignIn));



// WEBPACK FOOTER //
// ./src/desktop/components/signin/index.js